import { useSyncExternalStore } from "react";

// Docked chat windows along the bottom edge (desktop). Newest on the right; at most MAX open, the oldest closes.
const MAX = 3;
export interface DockWindow {
  id: string;
  minimized: boolean;
}
let windows: DockWindow[] = [];
let panelOpen = false;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());
const subscribe = (l: () => void) => {
  listeners.add(l);
  return () => listeners.delete(l);
};

export function openWindow(id: string) {
  windows = [...windows.filter((w) => w.id !== id), { id, minimized: false }].slice(-MAX);
  emit();
}
export function closeWindow(id: string) {
  windows = windows.filter((w) => w.id !== id);
  emit();
}
export function toggleMinimized(id: string) {
  windows = windows.map((w) => (w.id === id ? { ...w, minimized: !w.minimized } : w));
  emit();
}
export function setPanelOpen(open: boolean) {
  panelOpen = open;
  emit();
}
export function useDock() {
  const w = useSyncExternalStore(subscribe, () => windows);
  const p = useSyncExternalStore(subscribe, () => panelOpen);
  return { windows: w, panelOpen: p };
}
